import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnitsForUnitsOverviewQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.UnitOverviewFilterInput>;
  order?: Types.InputMaybe<Array<Types.UnitOverviewSortInput> | Types.UnitOverviewSortInput>;
  isLoggedIn?: Types.InputMaybe<Types.Scalars['Boolean']>;
  userId?: Types.InputMaybe<Types.Scalars['UUID']>;
}>;


export type GetUnitsForUnitsOverviewQuery = { __typename?: 'Query', unitOverview?: { __typename: 'UnitOverviewCollectionSegment', totalCount: number, items?: Array<{ __typename: 'UnitOverview', id: string, isImported: boolean, tenantId: string, certificateAuthorityId: string, modelName: string, manufacturerId: string, ratedCurrent?: number | null, unitCode?: string | null, maxActivePower?: number | null, hasActivePowerRange?: boolean | null, hasApparentPowerRange?: boolean | null, certificateId: string, maxActivePowerRange?: number | null, maxApparentPowerRange?: number | null, minActivePowerRange?: number | null, minApparentPowerRange?: number | null, ratedVoltage?: number | null, unitTypeId: string, createdAt: string, modifiedAt?: string | null, certificateNormIssueDateDescriptions?: string | null, is4105: boolean, category: Types.Category, certificateIsImported: boolean, isVerified?: boolean | null, certificateIssueDate?: string | null, certificateHolderId: string, certificateHolderName?: string | null, primaryEnergySource: Types.PrimaryEnergySource, certificateNumber: string, validityStartDate?: string | null, validityEndDate?: string | null, inEditByTenantId?: string | null, withTG8Rev25Conformity?: boolean | null, certificateValidityStatusName: string, certificateValidityStatusId: string, certificateTypeId: string, hasActiveErrorCorrection: boolean, hasActiveErrorReport: boolean, hasMatrixParameters: boolean, matrixType?: Types.MatrixType | null, matrixParameters?: { __typename?: 'MatrixParameters', taMax?: { __typename?: 'TimePowerParameters', taValue: number } | null } | null, inertiaParameters?: { __typename?: 'InertiaParameters', taGen: number, taZus: number, taGes: number } | null, replacedByCertificate?: { __typename?: 'Certificate', id: string, certificateNumber: string, revision?: number | null } | null, parentCertificateForValidityExtension?: { __typename?: 'Certificate', id: string, certificateNumber: string, revision?: number | null } | null }> | null } | null, unitBridgeUsers?: { __typename?: 'UnitBridgeUserCollectionSegment', items?: Array<{ __typename?: 'UnitBridgeUser', id: string, unitId: string }> | null } | null };


        export type ExecGetUnitsForUnitsOverviewOptions = Omit<
        Apollo.QueryOptions<
        GetUnitsForUnitsOverviewQueryVariables, GetUnitsForUnitsOverviewQuery
        >,
        "query"
      >;
    export const execGetUnitsForUnitsOverviewQuery = (options: ExecGetUnitsForUnitsOverviewOptions) =>
    client.query< GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>({
      ...options,
      query: GetUnitsForUnitsOverviewDocument,
    });
    

export const GetUnitsForUnitsOverviewDocument = gql`
    query getUnitsForUnitsOverview($skip: Int, $take: Int, $where: UnitOverviewFilterInput, $order: [UnitOverviewSortInput!], $isLoggedIn: Boolean = false, $userId: UUID) {
  unitOverview(skip: $skip, take: $take, where: $where, order: $order) {
    totalCount
    items {
      id
      isImported
      tenantId
      certificateAuthorityId
      modelName
      manufacturerId
      ratedCurrent
      unitCode
      maxActivePower
      hasActivePowerRange
      hasApparentPowerRange
      certificateId
      maxActivePower
      maxActivePowerRange
      maxApparentPowerRange
      minActivePowerRange
      minApparentPowerRange
      ratedVoltage
      unitTypeId
      createdAt
      modifiedAt
      certificateNormIssueDateDescriptions
      is4105
      unitTypeId
      category
      certificateIsImported
      isVerified
      certificateIssueDate
      certificateHolderId
      certificateHolderName
      primaryEnergySource
      certificateNumber
      validityStartDate
      validityEndDate
      inEditByTenantId
      withTG8Rev25Conformity
      certificateValidityStatusName
      certificateValidityStatusId
      certificateTypeId
      hasActiveErrorCorrection
      hasActiveErrorReport
      hasMatrixParameters
      matrixType
      matrixParameters {
        taMax {
          taValue
        }
      }
      inertiaParameters {
        taGen
        taZus
        taGes
      }
      replacedByCertificate {
        id
        certificateNumber
        revision
      }
      parentCertificateForValidityExtension {
        id
        certificateNumber
        revision
      }
      __typename
    }
    __typename
  }
  unitBridgeUsers(where: {userId: {eq: $userId}}) @include(if: $isLoggedIn) {
    items {
      id
      unitId
    }
  }
}
    `;

/**
 * __useGetUnitsForUnitsOverviewQuery__
 *
 * To run a query within a React component, call `useGetUnitsForUnitsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsForUnitsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsForUnitsOverviewQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      isLoggedIn: // value for 'isLoggedIn'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUnitsForUnitsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>(GetUnitsForUnitsOverviewDocument, options);
      }
export function useGetUnitsForUnitsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>(GetUnitsForUnitsOverviewDocument, options);
        }
export type GetUnitsForUnitsOverviewQueryHookResult = ReturnType<typeof useGetUnitsForUnitsOverviewQuery>;
export type GetUnitsForUnitsOverviewLazyQueryHookResult = ReturnType<typeof useGetUnitsForUnitsOverviewLazyQuery>;
export type GetUnitsForUnitsOverviewQueryResult = Apollo.QueryResult<GetUnitsForUnitsOverviewQuery, GetUnitsForUnitsOverviewQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;